<template>
  <div id="category" class="row">
    <div class="col-xl-4 col-lg-6 col-sm-12 col-md-12 cont" v-for="(wine, index) in wines">
      <card :wine="wine" ></card>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/Card'
  import {utility} from '../mixins/utility'
  export default {
    components: {Card},
    name: "category",
    mixins: [utility],
    data() {
      return {
        wines: []
      }
    },
    props: {
      category: {
        type: String,
        required: true,
        default: 'Spumanti'
      }
    },
    watch: {
      '$i18n.locale': function () {
        this.getAllWinesByCategory()
      }
    },
    mounted: function () {
      this.getAllWinesByCategory()
    },
    methods: {
      totale: function (){
        this.$emit('totCart')
      },
      getAllWinesByCategory: function () {
        this.wines = this.listWines.filter(el => el.nomeCat.toLowerCase() === this.category.toLowerCase())
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #category {
    color: white;
    width: 100%;
    margin-left: 0px;
    background-color: #585353;
    .row {
      margin-left: 0px;
      margin-right: 0px;
      input[type=number] {
        text-align: center;
        font-weight: 700;
        outline: none;
      }
      /*input[type=number]::-webkit-inner-spin-button,*/
      /*input[type=number]::-webkit-outer-spin-button {*/
        /*-webkit-appearance: initial;*/
        /*margin: 0;*/
      /*}*/
    }
    .cont {
      margin-top: 50px;
      padding-right: 0px;
      padding-left: 0px;
      .vino {
        border: .5px;
        border-style: solid;
        border-color: white;
        text-align: center;
        width: 65%;
        margin: auto;
        background-color: @lightBlack;
        padding: 20px;
        letter-spacing: 1px;
        .set-font-title(@size: 25px);
        .nomeVino {
          .set-font-latoLight(@size: 30px);
        }
        .nomeSmartbox {
          min-height: 100px;
          .set-font-latoLight(@size: 30px);
        }
        .quantity {
          .set-font-latoRegular();
          .quantità {
            width: 40%;
            height: 90%;
            background-color: #585353;
            color: white;
            border-color: @darkGray;
          }
        }
        .immagine {
          width: 80% !important;
        }
        .immagineSmartbox{
          width: 90% !important;
          padding-bottom: 20px;
        }
        .desc {
          text-align: center;
          min-height: 63px;
          .set-font-latoLight(@size: 16px);
        }
        .descSmartbox {
          text-align: left;
          min-height: 35px;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space: nowrap;
          .set-font-latoLight(@size: 16px);
        }
        .price {
          text-align: left;
          color: @lightGold;
          .set-font-latoRegular(@color: light-green);
        }
        .scheda {
          text-align: left;
          margin-bottom: 15px;
          .set-font-latoBold();
        }
        .info {
          border: 1px solid white;
          padding: 9px;
          width: 50% !important;
          margin: 40px auto;
          .set-font-latoLight();
        }
        .bottone {
          width: 200px;
          background-color: @myOrange;
          border-color: @borderOrange;
          margin: auto;
          text-align: center;
          display: inherit;
          letter-spacing: 1px;
          margin-bottom: 15px;
          .set-font()
        }
      }
      .notvino {
        border: .5px;
        border-style: solid;
        border-color: white;
        text-align: center;
        width: 65%;
        margin: auto;
        background-color: @lightBlack;
        padding: 20px;
        letter-spacing: 1px;
        .set-font-title(@size: 25px);
        .nomeVino {
          .set-font-latoLight(@size: 30px);
        }
        .quantity {
          .set-font-latoRegular();
          .quantità {
            width: 40%;
            height: 90%;
            background-color: #585353;
            color: white;
            border-color: @darkGray;
          }
        }
        .notimmagine {
          opacity: 0.4;
          width: 80% !important;
        }
        .notimmagineSmartbox {
          opacity: 0.4;
          width: 90% !important;
          padding-bottom: 20px;
        }
        .desc {
          text-align: left;
          min-height: 63px;
          max-height: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space: nowrap;
          .set-font-latoLight(@size: 16px);
        }
        .descSmartbox {
          text-align: left;
          min-height: 35px;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space: nowrap;
          .set-font-latoLight(@size: 16px);
        }
        .price {
          text-align: left;
          color: @lightGold;
          .set-font-latoRegular(@color: light-green);
        }
        .scheda {
          text-align: left;
          margin-bottom: 15px;
          .set-font-latoBold();
        }
        .info {
          border: 1px solid white;
          padding: 9px;
          width: 50% !important;
          margin: 40px auto;
          .set-font-latoLight();
        }
        .notbottone {
          text-align: center;
          margin-bottom: 15px;
          .set-font(@size: 20px, @color: orange)
        }
      }
    }
  }

  @media (max-width: 767px) {
    #category {
      .cont {
        .vino {
          .set-font-title(@size: 25px);
          .nomeVino {
            .set-font-latoLight(@size: 30px);
          }
          .quantity {
            .set-font-latoRegular();
            .quantità {
            }
          }
          .immagine {
          }
          .immagineSmartbox{
            width: 100% !important;
            padding: 10px;
          }
          .desc {
            min-height: 10px;
            .set-font-latoLight(@size: 16px);
          }
          .price {
            .set-font-latoRegular(@color: light-green);
          }
          .scheda {
            .set-font-latoBold();
          }
          .info {
            .set-font-latoLight();
          }
          .bottone {
            .set-font()
          }
        }
        .notvino {
          .set-font-title(@size: 25px);
          .nomeVino {
            .set-font-latoLight(@size: 30px);
          }
          .quantity {
            .set-font-latoRegular();
            .quantità {
            }
          }
          .notimmagine {
          }
          .notimmagineSmartbox {
            width: 100% !important;
            padding: 10px;
          }
          .desc {
            .set-font-latoLight(@size: 16px);
          }
          .descSmartbox {
            .set-font-latoLight(@size: 16px);
          }
          .price {
            .set-font-latoRegular(@color: light-green);
          }
          .scheda {
            .set-font-latoBold();
          }
          .info {
            .set-font-latoLight();
          }
          .notbottone {
            .set-font(@size: 20px, @color: orange)
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #category {
      .cont {
        .vino {
          .set-font-title(@size: 25px);
          .nomeVino {
            .set-font-latoLight(@size: 30px);
          }
          .quantity {
            .set-font-latoRegular();
            .quantità {
            }
          }
          .immagine {
          }
          .desc {
            min-height: 10px;
            .set-font-latoLight(@size: 16px);
          }
          .price {
            .set-font-latoRegular(@color: light-green);
          }
          .scheda {
            .set-font-latoBold();
          }
          .info {
            .set-font-latoLight();
          }
          .bottone {
            .set-font()
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    #category {
      .cont {
        .vino {
          .set-font-title(@size: 25px);
          .nomeVino {
            .set-font-latoLight(@size: 30px);
          }
          .quantity {
            .set-font-latoRegular();
            .quantità {
            }
          }
          .immagine {
          }
          .desc {
            min-height: 10px;
            .set-font-latoLight(@size: 16px);
          }
          .price {
            .set-font-latoRegular(@color: light-green);
          }
          .scheda {
            .set-font-latoBold();
          }
          .info {
            .set-font-latoLight();
          }
          .bottone {
            .set-font()
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Category.vue